var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isOnline)?_c('div',{class:_vm.$style.badge},[_c('OfflineIcon'),_c('span',{class:_vm.$style.text},[_vm._v("\n    "+_vm._s(_vm.$t('game.offline'))+"\n  ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }